import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import TopCompanies from '../components/topcompanies';
import How from '../components/how';
import Steps from '../components/steps';
import WhoCanJoin from '../components/whocanjoin';
import Hero from '../components/hero';
import Layout from '../components/layout';
import SEO from '../components/seo';
import { indexMenuLinks } from '../components/_config/menu-links';

const Index = ({ data }) => {
  const heroData = {
    tagline: data.hero.frontmatter.tagline,
    ctaLabel: data.hero.frontmatter.cta_label,
    ctaLink: data.hero.frontmatter.cta_link,
    secondctaLabel: data.hero.frontmatter.second_cta_label,
    secondctaLink: data.hero.frontmatter.second_cta_link,
    summary: data.hero.frontmatter.summary,
  };
  const howData = {
    summary: data.how.frontmatter.summary,
  };
  const whoData = {
    summary: data.whocanjoin.frontmatter.summary,
  };
  const companyData = {
    summary: data.topcompanies.frontmatter.summary,
  };
  const stepsData = {
    cards: data.steps.frontmatter.cards,
    summary: data.steps.frontmatter.summary,
    title: '3 easy steps to get started',
    id: 'features',
  };

  return (
    <Layout menuLinks={indexMenuLinks}>
      <SEO title="Home" />
      <Hero data={heroData} />
      <How data={howData} />
      <WhoCanJoin data={whoData} />
      <Steps data={stepsData} />
      <TopCompanies data={companyData} />
    </Layout>
  );
};

Index.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Index;

export const query = graphql`
  {
    site {
      siteMetadata {
        author
      }
    }

    hero: markdownRemark(fileAbsolutePath: { regex: "/content/sections/hero/" }) {
      frontmatter {
        tagline
        cta_label
        cta_link
        second_cta_label
        second_cta_link
        summary
      }
    }

    steps: markdownRemark(fileAbsolutePath: { regex: "/content/sections/steps/" }) {
      frontmatter {
        cards {
          label
          description
        }
        summary
      }
    }

    how: markdownRemark(fileAbsolutePath: { regex: "/content/sections/how/" }) {
      frontmatter {
        summary
      }
    }
    whocanjoin: markdownRemark(fileAbsolutePath: { regex: "/content/sections/whocanjoin/" }) {
      frontmatter {
        summary
      }
    }
    topcompanies: markdownRemark(fileAbsolutePath: { regex: "/content/sections/topcompanies/" }) {
      frontmatter {
        summary
      }
    }
  }
`;
